import Vue from 'vue';

export default Vue.observable({
    apiCalls: false,
    menuIsOpen: false,
    search: "",
    searchBar: false,
    searchResults: [],
    noResults: false,
    searchLoader: false,
    screen: null,
    bigScreen: false,
    smallScreen: false,
    device: null,
    contentInfo: {
        open: false,
        content: null,
        details: null
    },
    cardInfo: {
        open: false,
        timeout: null
    },
    saved: [],
    savedIds: [],
    pages: ['Home', 'TV series', 'Movies', 'New and popular', 'My list'],
    selected: 'Home',
    trending: {
        allWeek: [],
        moviesWeek: [],
        seriesWeek: [],
        allDay: [],
        moviesDay: [],
        seriesDay: [],
    },
    top10: [],
    top10Movies: [],
    top10Series: [],
    genres: [],
});